// extracted by mini-css-extract-plugin
export default {"button":"fp-z","reviewSort":"gp-z"};